import { render, staticRenderFns } from "./type1.vue?vue&type=template&id=0c140ff9"
import script from "./type1.vue?vue&type=script&lang=js"
export * from "./type1.vue?vue&type=script&lang=js"
import style0 from "./type1.vue?vue&type=style&index=0&id=0c140ff9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports